import type { IEditorViewInputState } from './editor-view-input.types';

export const namespace = 'editorViewInput';

export function getDefaultState(): IEditorViewInputState {
  return {
    updatingInputs: [],
    failedInputUpdates: [],
    alert: null,
  };
}

export enum EditorViewInputAction {
  UpdateInputValue = 'updateInputValue',
  UpdateInputValueSuccess = 'updateInputValueSuccess',
  UpdateInputValueFailed = 'updateInputValueFailed',
  SetAlert = 'setAlert',
}

export enum EditorViewInputMutation {
  AddUpdatingInput = 'addUpdatingInput',
  RemoveUpdatingInput = 'removeUpdatingInput',
  ClearFailedInputUpdates = 'clearFailedInputUpdates',
  AddToFailedInputUpdates = 'addToFailedInputUpdates',
  SetAlert = 'setAlert',
}
